// Simulador do WhatsApp (E13): só entra no pacote do portal quando o build tem REACT_APP_SIMULADOR_WHATSAPP=true (no
// .env do workspace de desenvolvimento, que não é versionado). Sem a variável, o padrão seguro: o webpack troca a
// condição por false e o require some do pacote, com todo o módulo. Não dá para usar NODE_ENV: os dois ambientes
// publicam com npm run build.

import { AppStorage } from 'src/utils'

export const SIMULADOR_WHATSAPP = process.env.REACT_APP_SIMULADOR_WHATSAPP === 'true'

/** O simulador lê a conversa de qualquer parceiro: só admin, como no servidor (usuarioDoChat). */
export function podeUsarSimulador(): boolean {
    return SIMULADOR_WHATSAPP && AppStorage.singleton().userRole === 'admin'
}

type ModuloSimulador = typeof import('./modules/simulador')

// A condição fica escrita no require (e não na constante acima) para o webpack resolvê-la no build.
export const moduloSimulador: ModuloSimulador | undefined =
    process.env.REACT_APP_SIMULADOR_WHATSAPP === 'true'
        ? // eslint-disable-next-line @typescript-eslint/no-var-requires
          (require('./modules/simulador') as ModuloSimulador)
        : undefined
